// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ticket-agreement{display:grid;grid-template-columns:10% auto}.ticket-agreement>.checkbox{height:20px;width:20px;justify-self:center;align-content:center}.ticket-agreement span{font-size:1.1em}.ticket-agreement div:nth-child(2)>div{margin-top:8px}.action-btn{height:50px}.action-btn.btn-disabled{background:#a3ceea}.gap{gap:10px}.ldr{position:relative}", ""]);
// Exports
module.exports = exports;
